import {createSelector} from '@reduxjs/toolkit';

import {ProfileState, type} from './state';

const featureStateSelector = (state: { [type]: ProfileState }) =>
    state[type];

export const selectedIdSelector = createSelector(
    featureStateSelector,
    state => state.selectedLearnerId
);

export const isFetchingSelector = createSelector(
    featureStateSelector,
    state => state.isFetching
);

export const isLoadingSelector = createSelector(
    featureStateSelector,
    state => state.isLoading
);

export const errorMessageSelector = createSelector(
    featureStateSelector,
    state => state.errorMessage
);
